var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconUploadDocuments = function SvgIconUploadDocuments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-495 -246) translate(495 246.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "#1A171B"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F6BF00",
    d: "M7.605 2.947c0 .681-.551 1.235-1.233 1.235-.68 0-1.233-.554-1.233-1.235 0-.682.553-1.234 1.233-1.234.682 0 1.233.552 1.233 1.234",
    transform: "translate(4 4) translate(3 1.333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A171B",
    d: "M3.572 3.849c.474 0 .923.206 1.23.565l1.96 2.523c.058.075.09.164.09.258 0 .132-.061.254-.165.334-.075.058-.164.088-.259.088-.132 0-.254-.06-.335-.163l-1.94-2.497c-.023-.027-.046-.05-.07-.071l-.088-.078v5.154c0 .233-.19.422-.423.422-.234 0-.423-.19-.423-.422V4.81l-.088.077c-.024.021-.047.044-.069.068l-1.941 2.5c-.081.104-.203.163-.336.163-.094 0-.183-.03-.258-.088-.105-.08-.164-.202-.164-.334 0-.094.03-.183.088-.258l1.948-2.506c.32-.376.768-.582 1.243-.582zm3.755 8.349l1.076-1.34H7.327v1.34zM1.643 13.23c-.744 0-1.35-.605-1.35-1.347v-.973c0-.233.19-.422.423-.422.234 0 .423.19.423.422v.973c0 .277.226.502.504.502h4.838v-1.95c0-.232.19-.42.423-.42H8.86V1.4c0-.278-.226-.503-.505-.503H1.643c-.278 0-.504.225-.504.503v1.92c0 .233-.19.423-.423.423-.233 0-.423-.19-.423-.422V1.4C.293.658.899.054 1.643.054h6.713c.745 0 1.351.604 1.351 1.347v9.036c0 .094-.032.188-.093.263L7.71 13.072c-.08.1-.201.159-.33.159H1.643z",
    transform: "translate(4 4) translate(3 1.333)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUploadDocuments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_upload_documents.3875df19.svg";
export { ForwardRef as ReactComponent };